import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Calender from '../../../departure/components/calender';
import _filter from 'lodash/filter';
import { AddReservationsPayload,  AddTripPayload } from '../../../../helpers/bookingHelper';
import { UpdateTripInfo, AddTripInfo } from '../../../../actions/booking';
import { SetCityID } from '../../../../actions/currentBooking';
import BasketProductList from '../../../departure/basketproductlist';
import { CYOA_NETWORK_IDS } from '../../../../config';

class CalenderPanel extends PureComponent {

  constructor(props){
    super(props);
    this.onConfirm = this.onConfirm.bind(this);
    this.onClose = this.onClose.bind(this);
  }


  onConfirm(){

    const {
      currentBooking,
      UpdateTripInfo,
      destinations,
      AddTripInfo,
      capacity,
      SetCityID,
      onCalendarClose,
      id,
      editIndex,
      onCloseCalender,
      itineraries,
      itineraries:{tms_group_booking_id, sectors}
    } = this.props;

    const departureDate = currentBooking.trips[0].departure_date;

    if(id === 'next-destination-panel'){

      // Check if sector or tour, and update and add accordingly
      if(currentBooking.trips[0].city_id !== "0"){

        const startOrEndId = _filter(destinations, ['tms_stage_id', currentBooking.trips[0].city_id])[0];
        const selectedPrice = _filter(capacity.data, ['departure_date', departureDate])[0].price_adult;

        const payload = AddReservationsPayload(itineraries, departureDate, startOrEndId.departure_id, startOrEndId.tms_stage_id, selectedPrice);

        UpdateTripInfo(tms_group_booking_id, "add_sectors", payload).then(() => {
           onCalendarClose('next-destination');
           SetCityID("0");
        });

      }else{

        const isCyoaTours = (capacity.header.tour_id !== CYOA_NETWORK_IDS["europe"].id || capacity.header.tour_id !== CYOA_NETWORK_IDS["usa"].id);
        const hasProductOptions = (capacity.length !== 0 && isCyoaTours && capacity.header.product_options.length > 1) ? currentBooking.trips[0].tour_id : capacity.header.tour_id;
        const lastSectorEndCityId = sectors[sectors.length - 1].transfer.end_city_id;

        const payload = AddTripPayload(itineraries, hasProductOptions, departureDate, lastSectorEndCityId);

        AddTripInfo(tms_group_booking_id, "add_trips", payload).then(() => {
           onCalendarClose('next-destination');
        });
      }

    }

    if(id === 'edit-panel'){

      const lastSectorEndCityId = sectors[editIndex - 1].transfer.end_city_id;

      const payload = AddTripPayload(itineraries, capacity.header.tour_id, departureDate, lastSectorEndCityId);

      UpdateTripInfo(tms_group_booking_id, "update_trips", payload).then(() => {
        onCloseCalender();
      });
    }


  }

  onClose(){

    const { id, onCalendarClose, onCloseCalender } = this.props;

    if(id === 'next-destination-panel') onCalendarClose('destination');
    if(id === 'edit-panel') onCloseCalender();

  }


  render(){
    const { currentBooking, destinations, isUpdating, capacity, id, editIndex, itineraries:{sectors} } = this.props;

    // Check for tour with product options (options dropdown)
    const isCyoaTours = (capacity.header.tour_id !== CYOA_NETWORK_IDS["europe"].id || capacity.header.tour_id !== CYOA_NETWORK_IDS["usa"].id);
    const _hasProductOptions = capacity.length !== 0 && isCyoaTours && capacity.header.product_options.length > 1;


    // Check if tourID is CYO or fixed tour
    let _departureText, _arriveText;


    if(id === 'next-destination-panel'){

      //Check if last reservations is sector or tour
      if(currentBooking.trips[0].city_id !== "0"){
        const lastItem = sectors[sectors.length - 1];
        const isCyoaTours = (lastItem.tour_id === CYOA_NETWORK_IDS["europe"].id || lastItem.tour_id === CYOA_NETWORK_IDS["usa"].id);  
         _departureText = isCyoaTours ? lastItem.transfer.end_city : lastItem.city;
         _arriveText = Object.keys(currentBooking).length > 0 ? _filter(destinations, ['tms_stage_id', currentBooking.trips[0].city_id])[0].name : "";
      }else{
        _departureText = (sectors.length !== 0) ? sectors[sectors.length - 1].transfer.end_city : "";
        _arriveText = /*this.props.capacity.header.name +*/ " (Trip)";
      }

    }

    if(id === 'edit-panel'){
      _departureText = (editIndex !== null) ? sectors[editIndex - 1].city : "";
      _arriveText = (editIndex !== null) ? sectors[editIndex].city : "";
    }

    return (
      <div className="calendar-panel">

        <div className="calendar-panel-text">
          <div className="row">
            <div className="column small-10">
                <p className="depart-arrive-text">
                  <span className="sub-text">Departing</span>
                  <span className="city-text">{_departureText}</span>
                </p>

                <p className="arrow orange-text">
                  &rarr;
                </p>

                <p className="depart-arrive-text">
                  <span className="sub-text">Arriving</span>
                  <span className="city-text">{_arriveText}</span>
                </p>
            </div>

            <div className="column small-2">
              <svg width="19" height="19" className="calendar-panel-close"  viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg" onClick={this.onClose}>
                <path d="M10.978 9.56l7.673-7.713a.678.678 0 0 0 0-.956l-.475-.478a.67.67 0 0 0-.951 0L9.552 8.127 1.88.418a.67.67 0 0 0-.95 0L.453.896a.678.678 0 0 0 0 .956L8.126 9.56.46 17.274a.678.678 0 0 0 0 .956l.475.478a.67.67 0 0 0 .95 0l7.667-7.714 7.673 7.714a.67.67 0 0 0 .95 0l.476-.478a.678.678 0 0 0 0-.956L10.978 9.56z" fill="#F14859" fillRule="nonzero" opacity=".501"/>
              </svg>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="column small-12">
            { _hasProductOptions && <BasketProductList isedit={true} dropdownlist={capacity} /> }
          </div>
        </div>

        <div className="row">
          <div className="column small-12">
            <Calender iscyoa={true} isedit={true}  />
          </div>
        </div>

        <div className="row">
          <div className="column small-12">
            <button
              type="submit"
              className={`calender-confirm-btn busabout--cta orange ${(currentBooking.trips[0].departure_date !== "" && currentBooking.passengers.length > 0) ? '': 'disabled'}` }
              disabled={ (currentBooking.trips[0].departure_date !== "" && currentBooking.passengers.length > 0) ? false : true}
              onClick={this.onConfirm}>
                <span style={{display:isUpdating ? "none" : "block"}}>confirm</span>
                <span style={{display:isUpdating ? "block" : "none"}}><span className="fa fa-spinner fa-lg fa-spin"></span></span>
            </button>
          </div>
        </div>

      </div>
    )
  }

}



function mapStateToProps(state){
  return {
    destinations:state.destinations.data,
    currentBooking:state.currentBooking,
    isUpdating:state.bookingGroup.updating,
    capacity:state.capacity.data,
    itineraries:state.itineraries.data
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    UpdateTripInfo,
    AddTripInfo,
    SetCityID,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CalenderPanel);



// WEBPACK FOOTER //
// ./src/components/itinerary/editTrip/components/calendar-panel.js